// import bindAll from 'lodash.bindall';
// import PropTypes from 'prop-types';
// import React from 'react';
// import {connect} from 'react-redux';
// import {projectTitleInitialState} from '../reducers/project-title';
// import downloadBlob from '../lib/download-blob';
// /**
//  * Project saver component passes a downloadProject function to its child.
//  * It expects this child to be a function with the signature
//  *     function (downloadProject, props) {}
//  * The component can then be used to attach project saving functionality
//  * to any other component:
//  *
//  * <SB3Downloader>{(downloadProject, props) => (
//  *     <MyCoolComponent
//  *         onClick={downloadProject}
//  *         {...props}
//  *     />
//  * )}</SB3Downloader>
//  */
// class SB3Downloader extends React.Component {
//     constructor (props) {
//         super(props);
//         bindAll(this, [
//             'downloadProject'
//         ]);
//     }
//     downloadProject () {
//         this.props.saveProjectSb3().then(content => {
//             if (this.props.onSaveFinished) {
//                 this.props.onSaveFinished();
//             }
//             downloadBlob(this.props.projectFilename, content);
//         });
//     }
//     render () {
//         const {
//             children
//         } = this.props;
//         return children(
//             this.props.className,
//             this.downloadProject
//         );
//     }
// }

// const getProjectFilename = (curTitle, defaultTitle) => {
//     let filenameTitle = curTitle;
//     if (!filenameTitle || filenameTitle.length === 0) {
//         filenameTitle = defaultTitle;
//     }
//     return `${filenameTitle.substring(0, 100)}.sb3`;
// };

// SB3Downloader.propTypes = {
//     children: PropTypes.func,
//     className: PropTypes.string,
//     onSaveFinished: PropTypes.func,
//     projectFilename: PropTypes.string,
//     saveProjectSb3: PropTypes.func
// };
// SB3Downloader.defaultProps = {
//     className: ''
// };

// const mapStateToProps = state => ({
//     saveProjectSb3: state.scratchGui.vm.saveProjectSb3.bind(state.scratchGui.vm),
//     projectFilename: getProjectFilename(state.scratchGui.projectTitle, projectTitleInitialState)
// });

// export default connect(
//     mapStateToProps,
//     () => ({}) // omit dispatch prop
// )(SB3Downloader);


import bindAll from 'lodash.bindall';
import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import {projectTitleInitialState} from '../reducers/project-title';
import downloadBlob from '../lib/download-blob';

class SB3Downloader extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, [
            'downloadProject',
            'uploadProjectToServer'
        ]);
        this.state = {
            isUploading: false
        };
    }

    downloadProject () {
        // 现在改为上传到服务器，但保持相同的函数签名
        return this.uploadProjectToServer();
    }

    async uploadProjectToServer () {
        console.log("=uploadProjectToServer==uploadProjectToServer==")
        this.setState({ isUploading: true });

        try {
            // 1. 先获取项目内容（保持原有逻辑）
            const content = await this.props.saveProjectSb3();
            
            // 2. 创建 FormData 用于文件上传
            const formData = new FormData();
            const blob = new Blob([content], { type: 'application/octet-stream' });
            //  formData.append('projectFile', blob, this.props.projectFilename);
           
           const ext = this.props.projectFilename.slice(
             (Math.max(0, this.props.projectFilename.lastIndexOf('.')) || Infinity) + 1
                );
            const newFilename = `${Math.floor(Math.random() * 10000)}${ext ? '.' + ext : ''}`;

            formData.append('projectFile', blob, newFilename);

            const urlParams = new URLSearchParams(window.location.search);
            const id = urlParams.get('id');

            // formData.append('projectName', this.props.projectTitle || 'Untitled');
            formData.append('projectName', Math.random());
            formData.append('id', id);
            
            // 3. 上传到 Node.js 服务器
            const response = await this.uploadToServer(formData);
            
            // 4. 可选：如果用户仍然想要下载到本地，可以取消注释下面这行
            // downloadBlob(this.props.projectFilename, content);
            
            // 5. 触发完成回调
            if (this.props.onSaveFinished) {
                this.props.onSaveFinished();
            }
            
            console.log('Project uploaded successfully:', response);
            return response;
            
        } catch (error) {
            console.error('Upload failed:', error);
            if (this.props.onUploadError) {
                this.props.onUploadError(error);
            }
            throw error;
        } finally {
            this.setState({ isUploading: false });
        }
    }

    async uploadToServer(formData) {
        const UPLOAD_URL = 'https://sc.2-1.me/api/upload'; // 替换为你的服务器地址
        
        return new Promise((resolve, reject) => {
            const xhr = new XMLHttpRequest();
            
            xhr.addEventListener('load', () => {
                if (xhr.status >= 200 && xhr.status < 300) {
                    try {
                        const response = JSON.parse(xhr.responseText);
                        resolve(response);
                    } catch (error) {
                        resolve({ success: true, message: 'Upload completed' });
                    }
                } else {
                    reject(new Error(`Upload failed with status ${xhr.status}`));
                }
            });
            
            xhr.addEventListener('error', () => {
                reject(new Error('Network error occurred during upload'));
            });
            
            xhr.open('POST', UPLOAD_URL, true);
            xhr.send(formData);
        });
    }

    render () {
        const {
            children
        } = this.props;
        return children(
            this.props.className,
            this.downloadProject // 仍然传递 downloadProject 方法以保持接口兼容
        );
    }
}

const getProjectFilename = (curTitle, defaultTitle) => {
    let filenameTitle = curTitle;
    if (!filenameTitle || filenameTitle.length === 0) {
        filenameTitle = defaultTitle;
    }
    return `${filenameTitle.substring(0, 100)}.sb3`;
};

SB3Downloader.propTypes = {
    children: PropTypes.func,
    className: PropTypes.string,
    onSaveFinished: PropTypes.func,
    onUploadError: PropTypes.func,
    projectFilename: PropTypes.string,
    projectTitle: PropTypes.string,
    saveProjectSb3: PropTypes.func
};

SB3Downloader.defaultProps = {
    className: '',
    onSaveFinished: null,
    onUploadError: null
};

const mapStateToProps = state => ({
    saveProjectSb3: state.scratchGui.vm.saveProjectSb3.bind(state.scratchGui.vm),
    projectFilename: getProjectFilename(state.scratchGui.projectTitle, projectTitleInitialState),
    projectTitle: state.scratchGui.projectTitle
});

export default connect(
    mapStateToProps,
    () => ({})
)(SB3Downloader);


